import React from 'react';
import './PasosTienda.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStore, faArrowRight } from '@fortawesome/free-solid-svg-icons';

export default function PasosTienda() {
    const pasos = [
        {
            numero: '01',
            titulo: 'CREA TU CUENTA',
            descripcion: 'Elige: Vendes productos con delivery o trabajas por turnos.'
        },
        {
            numero: '02',
            titulo: 'CONFIGURA TU TIENDA',
            descripcion: 'Personaliza tu logo, colores, datos de contacto, horarios de atención y métodos de pago.'
        },
        {
            numero: '03',
            titulo: 'SUBE TUS PRODUCTOS',
            descripcion: 'Publica tu catálogo con fotos atractivas, precios, promociones y opciones de reserva.'
        },
        {
            numero: '04',
            titulo: '¡LISTO PARA VENDER!',
            descripcion: 'Comparte tu enlace personalizado, recibe pedidos directos por WhatsApp y automatiza tu negocio.'
        }
    ];

    const handleAbrirRegistro = (e) => {
        if (e) e.preventDefault();
        window.dispatchEvent(new CustomEvent('open-auth-modal', {
            cancelable: true,
            detail: { tab: 'register' }
        }));
    };

    return (
        <section className="pasosTiendaSection">
            <div className="pasosTiendaOverlay"></div>

            <div className="pasosTiendaContainer">
                {/* Cabecera del bloque */}
                <div className="pasosTiendaHeader">
                    <h2 className="pasosTiendaTitle">
                        ¿TIENES UN NEGOCIO O ERES EMPRENDEDOR?
                    </h2>
                    <p className="pasosTiendaSubtitle">
                        Digitaliza tu negocio en pocos minutos. Publica tus productos o servicios, gestiona tus pedidos y reservas, y haz crecer tus ventas desde una sola plataforma.
                    </p>
                </div>

                {/* Línea de tiempo de pasos */}
                <div className="pasosTiendaTimelineWrapper">
                    <div className="pasosConnectingLine" aria-hidden="true"></div>

                    <div className="pasosTiendaGrid">
                        {pasos.map((paso, idx) => (
                            <div key={idx} className="pasoTiendaItem">
                                <div className="pasoCircleWrapper">
                                    <div className="pasoCircle">
                                        <span>{paso.numero}</span>
                                    </div>
                                </div>
                                <div className="pasoContent">
                                    <h3 className="pasoTitle">{paso.titulo}</h3>
                                    <p className="pasoDesc">{paso.descripcion}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Llamado a la acción (CTA) */}
                <div className="pasosTiendaCta">
                    <button
                        type="button"
                        onClick={handleAbrirRegistro}
                        className="btnPasosCta"
                        title="Crear mi cuenta y abrir mi tienda en Club Vende Más"
                    >
                        <FontAwesomeIcon icon={faStore} className="btnPasosIcon" />
                        <span>¡Crea tu tienda ahora y empieza a vender!</span>
                        <FontAwesomeIcon icon={faArrowRight} className="btnPasosArrow" />
                    </button>
                </div>
            </div>
        </section>
    );
}
